"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-913ae6ec"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "header-text" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 業務セクション "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", {
        href: "https://x.gd/u1xzU",
        target: "_blank",
        class: "circle-question"
    })
], -1 /* HOISTED */));
const _hoisted_2 = { class: "content-wrapper d-flex flex-wrap" };
const _hoisted_3 = ["onClick"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../vue/Modal.vue"));
const models_1 = require("../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionListModal',
    props: {
        isLoading: { type: Boolean }
    },
    emits: ["close-modal", "role-section-submit"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const roleSectionsData = (0, vue_3.inject)('roleSectionsData');
        const selectedRoleId = (0, vue_3.ref)(0);
        const buttonClass = (0, vue_3.computed)(() => {
            return {
                'loading': props.isLoading,
                'disabled-btn': !selectedRoleId.value
            };
        });
        const emits = __emit;
        function closeSectionModal() {
            emits('close-modal');
        }
        function handleRoleSectionSelect(roleSection) {
            if (selectedRoleId.value === roleSection.id) {
                selectedRoleId.value = 0;
                return;
            }
            selectedRoleId.value = roleSection.id;
        }
        function submitSection() {
            if (selectedRoleId.value) {
                emits('role-section-submit', selectedRoleId.value);
            }
        }
        function roleStyle(role) {
            return {
                backgroundColor: `#${role.color ? role.color : models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: role.color ? '#fff' : ''
            };
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                onCloseModal: closeSectionModal,
                "has-title-divider": true,
                "has-footer-divider": false
            }, {
                "header-title": (0, vue_2.withCtx)(() => [
                    _hoisted_1
                ]),
                content: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(roleSectionsData), (roleSection) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: roleSection.id
                            }, [
                                (0, vue_2.createElementVNode)("span", {
                                    onClick: ($event) => (handleRoleSectionSelect(roleSection)),
                                    class: (0, vue_2.normalizeClass)(["chip c-hand role-section-slot-chip", { 'active': selectedRoleId.value === roleSection.id }]),
                                    style: (0, vue_2.normalizeStyle)(roleStyle(roleSection))
                                }, (0, vue_2.toDisplayString)(roleSection.name), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_3)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                "footer-btn": (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("button", {
                        id: "section-submit",
                        class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", buttonClass.value]),
                        onClick: _cache[0] || (_cache[0] = ($event) => { submitSection(); })
                    }, "編集", 2 /* CLASS */)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
